import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BsSpeedometer, BsPatchPlus, BsUiRadiosGrid, BsBoxArrowInLeft, BsList, BsX } from 'react-icons/bs';

const DashboardListings = () => {
  const location = useLocation();
  const current = location.pathname;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const showToast = () => {
    const toast = document.getElementById('actionToast');
    if (toast) {
      toast.classList.remove('translate-y-24');
    }
  };

  const hideToast = () => {
    const toast = document.getElementById('actionToast');
    if (toast) {
      toast.classList.add('translate-y-24');
    }
  };

  // Add event listeners to simulate row interactions
  useEffect(() => {
    const rows = document.querySelectorAll('.listing-row');
    rows.forEach((row) => {
      row.addEventListener('click', () => {
        console.log('Row clicked');
      });
    });

    return () => {
      rows.forEach((row) => {
        row.removeEventListener('click', () => { });
      });
    };
  }, []);

  // Close drawer on route change
  useEffect(() => {
    closeDrawer();
  }, [current]);

  return (
    <>
      <div className="flex min-h-screen overflow-hidden">
        {/* Mobile Overlay */}
        {isDrawerOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity duration-300"
            onClick={closeDrawer}
          />
        )}

        {/* Sidebar - Desktop */}
        <aside className="hidden md:flex flex-col w-72 bg-white border-r border-red-100 shadow-sm flex-shrink-0 z-30">
          {/* Sidebar Header */}
          <div className="p-6 border-b border-red-100">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-red-600 to-rose-700 flex items-center justify-center shadow-lg shadow-red-500/20">
                <span className="text-white text-xl font-bold">TL</span>
              </div>
              <div>
                <h1 className="text-lg font-bold text-gray-900">The Locksmith</h1>
                <p className="text-xs text-gray-500">USA Network</p>
              </div>
            </div>

          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-6">
            <p className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Main Menu</p>
            <ul className="space-y-1.5">
              <li>
                <Link
                  to="/admin"
                  className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 group ${current === '/dashboard-user'
                      ? 'bg-red-50 text-red-700 font-semibold shadow-sm border border-red-100'
                      : 'text-gray-600 hover:bg-red-50/50 hover:text-red-700'
                    }`}
                >
                  <BsSpeedometer className={`text-lg mr-3 transition-transform group-hover:scale-110 ${current === '/dashboard-user' ? 'text-red-600' : 'text-gray-400 group-hover:text-red-500'
                    }`} />
                  <span className="text-sm">Dashboard Area</span>
                  {current === '/dashboard-user' && (
                    <span className="ml-auto w-1.5 h-1.5 bg-red-600 rounded-full"></span>
                  )}
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/listings/add"
                  className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 group ${current === '/dashboard-add-listing'
                      ? 'bg-red-50 text-red-700 font-semibold shadow-sm border border-red-100'
                      : 'text-gray-600 hover:bg-red-50/50 hover:text-red-700'
                    }`}
                >
                  <BsPatchPlus className={`text-lg mr-3 transition-transform group-hover:scale-110 ${current === '/dashboard-add-listing' ? 'text-red-600' : 'text-gray-400 group-hover:text-red-500'
                    }`} />
                  <span className="text-sm">Add Listing</span>
                  {current === '/dashboard-add-listing' && (
                    <span className="ml-auto w-1.5 h-1.5 bg-red-600 rounded-full"></span>
                  )}
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/listings"
                  className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 group ${current === '/dashboard-my-listings'
                      ? 'bg-red-50 text-red-700 font-semibold shadow-sm border border-red-100'
                      : 'text-gray-600 hover:bg-red-50/50 hover:text-red-700'
                    }`}
                >
                  <BsUiRadiosGrid className={`text-lg mr-3 transition-transform group-hover:scale-110 ${current === '/dashboard-my-listings' ? 'text-red-600' : 'text-gray-400 group-hover:text-red-500'
                    }`} />
                  <span className="text-sm">My Listings</span>
                  {current === '/dashboard-my-listings' && (
                    <span className="ml-auto w-1.5 h-1.5 bg-red-600 rounded-full"></span>
                  )}
                </Link>
              </li>
            </ul>
          </nav>

          {/* Logout */}
          <div className="px-4 py-4 border-t border-red-100">
            <Link
              to="/admin/logout"
              className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 group ${current === '/logout'
                  ? 'bg-red-50 text-red-700 font-semibold'
                  : 'text-gray-500 hover:bg-red-50 hover:text-red-600'
                }`}
            >
              <BsBoxArrowInLeft className={`text-lg mr-3 transition-transform group-hover:-translate-x-1 ${current === '/logout' ? 'text-red-600' : 'text-gray-400 group-hover:text-red-500'
                }`} />
              <span className="text-sm">Logout</span>
            </Link>
          </div>
        </aside>

        {/* Mobile Drawer */}
        <aside className={`fixed inset-y-0 left-0 w-72 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out md:hidden ${isDrawerOpen ? 'translate-x-0' : '-translate-x-full'
          }`}>
          <div className="flex flex-col h-full">
            {/* Drawer Header */}
            <div className="p-6 border-b border-red-100">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-red-600 to-rose-700 flex items-center justify-center shadow-lg shadow-red-500/20">
                    <span className="text-white font-bold">TL</span>
                  </div>
                  <h1 className="text-lg font-bold text-gray-900">The Locksmith USA</h1>
                </div>
                <button
                  onClick={closeDrawer}
                  className="p-2 rounded-lg hover:bg-red-50 transition-colors"
                >
                  <BsX className="text-2xl text-gray-600" />
                </button>
              </div>
              <div className="flex items-center space-x-3 p-3 bg-red-50 rounded-xl border border-red-100">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-500 to-rose-600 flex items-center justify-center text-white font-bold">
                  LU
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">Locksmith USA</p>
                  <p className="text-xs text-red-600 flex items-center gap-1">
                    <span className="w-1.5 h-1.5 bg-red-500 rounded-full"></span>
                    Verified Professional
                  </p>
                </div>
              </div>
            </div>

            {/* Drawer Navigation */}
            <nav className="flex-1 px-4 py-6">
              <p className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Main Menu</p>
              <ul className="space-y-1.5">
                <li>
                  <Link
                    to="/admin"
                    onClick={closeDrawer}
                    className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 ${current === '/dashboard-user'
                        ? 'bg-red-50 text-red-700 font-semibold'
                        : 'text-gray-600 hover:bg-red-50/50'
                      }`}
                  >
                    <BsSpeedometer className={`text-lg mr-3 ${current === '/dashboard-user' ? 'text-red-600' : 'text-gray-400'}`} />
                    <span className="text-sm">Dashboard Area</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admin/listings/add"
                    onClick={closeDrawer}
                    className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 ${current === '/dashboard-add-listing'
                        ? 'bg-red-50 text-red-700 font-semibold'
                        : 'text-gray-600 hover:bg-red-50/50'
                      }`}
                  >
                    <BsPatchPlus className={`text-lg mr-3 ${current === '/dashboard-add-listing' ? 'text-red-600' : 'text-gray-400'}`} />
                    <span className="text-sm">Add Listing</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admin/listings"
                    onClick={closeDrawer}
                    className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 ${current === '/dashboard-my-listings'
                        ? 'bg-red-50 text-red-700 font-semibold'
                        : 'text-gray-600 hover:bg-red-50/50'
                      }`}
                  >
                    <BsUiRadiosGrid className={`text-lg mr-3 ${current === '/dashboard-my-listings' ? 'text-red-600' : 'text-gray-400'}`} />
                    <span className="text-sm">My Listings</span>
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Drawer Logout */}
            <div className="px-4 py-4 border-t border-red-100">
              <Link
                to="/admin/logout"
                onClick={closeDrawer}
                className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 ${current === '/logout'
                    ? 'bg-red-50 text-red-700 font-semibold'
                    : 'text-gray-500 hover:bg-red-50 hover:text-red-600'
                  }`}
              >
                <BsBoxArrowInLeft className={`text-lg mr-3 ${current === '/logout' ? 'text-red-600' : 'text-gray-400'}`} />
                <span className="text-sm">Logout</span>
              </Link>
            </div>
          </div>
        </aside>

        {/* Main Content Canvas */}
        <main className="flex-1 flex flex-col h-screen overflow-hidden">
          {/* Header Section */}
          <header className="bg-white border-b border-red-100 px-4 md:px-8 py-4 md:py-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                {/* Mobile Menu Button */}
                <button
                  onClick={toggleDrawer}
                  className="p-2 rounded-lg hover:bg-red-50 transition-colors md:hidden"
                >
                  <BsList className="text-2xl text-gray-700" />
                </button>
                <div>
                  <h2 className="text-xl md:text-2xl font-bold text-gray-900">Manage Listings</h2>
                  <p className="text-sm text-gray-500 mt-1 hidden md:block">
                    Review and manage all locksmith profiles across the network.
                  </p>
                </div>
              </div>
              <Link to={"/admin/listings/add"} className="bg-gradient-to-r from-red-600 to-rose-600 text-white px-4 md:px-6 py-2.5 md:py-3 rounded-xl font-semibold text-sm flex items-center gap-2 shadow-lg shadow-red-500/25 hover:shadow-xl hover:shadow-red-500/30 transition-all active:scale-95">
                <span className="text-lg">+</span>
                <span className="hidden md:inline">Add New Listing</span>
                <span className="md:hidden">Add</span>
              </Link>
            </div>
          </header>

          {/* Tool Bar: Search & Filters */}
          <section className="px-4 md:px-8 py-4 md:py-6">
            <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
              <div className="relative w-full md:w-96">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </span>
                <input
                  className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 bg-white focus:border-red-500 focus:ring-2 focus:ring-red-500/20 outline-none transition-all text-sm"
                  placeholder="Search by name, ID or region..."
                  type="text"
                />
              </div>
            </div>
          </section>

          {/* Data Table Section */}
          <section className="flex-1 px-4 md:px-8 pb-4 md:pb-0 overflow-hidden">
            <div className="h-full bg-white rounded-2xl border border-red-100 shadow-sm overflow-hidden flex flex-col">
              <div className="overflow-x-auto custom-scrollbar">
                <table className="w-full text-left border-collapse min-w-[800px]">
                  <thead>
                    <tr className="bg-gradient-to-r from-red-50 to-rose-50 border-b border-red-100">
                      <th className="px-6 py-4 text-xs font-semibold text-red-900 uppercase tracking-wider">
                        Profile
                      </th>
                      <th className="px-6 py-4 text-xs font-semibold text-red-900 uppercase tracking-wider">
                        Name & ID
                      </th>
                      <th className="px-6 py-4 text-xs font-semibold text-red-900 uppercase tracking-wider">
                        Service Area
                      </th>
                      <th className="px-6 py-4 text-xs font-semibold text-red-900 uppercase tracking-wider text-right">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-red-50">
                    {/* Row 1 */}
                    <tr className="listing-row transition-colors hover:bg-red-50/50 cursor-pointer">
                      <td className="px-6 py-4">
                        <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-200 ring-2 ring-red-100">
                          <img
                            className="w-full h-full object-cover"
                            alt="Professional locksmith"
                            src="https://lh3.googleusercontent.com/aida-public/AB6AXuAwehgf4KULmv2KZtDClmQY4Nm6cyuOKNxlTjRkRryyTkzVxYnjvLxEWDA3oNuHDbLnc5R_rtGM-scM67Z4NLv6c48afRoSiL-aV0zD8azvGs2UvhNvDZoaIUKn6hbPEfrSa-B_xttvsgLmIgPkMOxZWTpmFqlo7kJCngcNBpxR1vEWW8grECqtkkmvlhIHc4F6W391iF3knj_4-Bi5JqlZG_FqS8jhEg7xgFdFG9Au9K19of83bJTOS7vkaXeYzNAQdSV_42UfJ0Q"
                          />
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div>
                          <p className="text-sm font-semibold text-gray-900">Alex Sterling</p>
                          <p className="text-xs text-gray-500 mt-0.5">L-USA-9021</p>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-50 text-red-700">
                          Manhattan, NY
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button className="p-2 rounded-lg hover:bg-red-50 transition-colors">
                          <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                          </svg>
                        </button>
                      </td>
                    </tr>

                    {/* Row 2 */}
                    <tr className="listing-row transition-colors hover:bg-red-50/50 cursor-pointer">
                      <td className="px-6 py-4">
                        <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-200 ring-2 ring-red-100">
                          <img
                            className="w-full h-full object-cover"
                            alt="Professional locksmith"
                            src="https://lh3.googleusercontent.com/aida-public/AB6AXuD76fWGtzpFGmVRgP96j2WjCq5ZawszATr4LgYgF1ZnQThhQQa4PCvKYIfthqcKwhQc4fTH4tWbMwuG8ztkA3BbX593clnp1IGQZPtH9admGy2KtoAgu-ez_lxMRCY-3XGFw1AiokQL30L99cuF15DALh0GFOPZR1PUj1Y8V8D1kWSglDl5mOWB5Gh2nIoPzhkOov-BW_UhNJGTaap2qNjvj7f1tHXp9wGkQHB4ES9HvTJYodXapX3BlfyopSXVLm-rWDT5KiRLSFo"
                          />
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div>
                          <p className="text-sm font-semibold text-gray-900">Sarah Jennings</p>
                          <p className="text-xs text-gray-500 mt-0.5">L-USA-4432</p>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-rose-50 text-rose-700">
                          Chicago, IL
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button className="p-2 rounded-lg hover:bg-red-50 transition-colors">
                          <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                          </svg>
                        </button>
                      </td>
                    </tr>

                    {/* Row 3 */}
                    <tr className="listing-row transition-colors hover:bg-red-50/50 cursor-pointer">
                      <td className="px-6 py-4">
                        <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-200 ring-2 ring-red-100">
                          <img
                            className="w-full h-full object-cover"
                            alt="Professional locksmith"
                            src="https://lh3.googleusercontent.com/aida-public/AB6AXuAgu1YVdSWZgfpAKXpcufLVx-hC-ofs36dKt2woHfL4BLmhgDDuzpUyFUfPBKuDq2G-MnJ98W47TCwjlcVst73TS114M9B90oPTPJnu-cHz7KBq7Avzn6iWOgn_miEQdkcpsdYGAtu6OQz7X_Ms03OStovmo8noNg7daw2SdwF26QOr9GzvwNAcBRD5HHve0C2ATQl0kHdizeYxheM5kjVH34lA2BmQVaOAHNSYxnYchTLe-bH_1uYF86ZwkaEiTKHlXeBeNrI6GAU"
                          />
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div>
                          <p className="text-sm font-semibold text-gray-900">David Miller</p>
                          <p className="text-xs text-gray-500 mt-0.5">L-USA-1108</p>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-50 text-red-700">
                          Austin, TX
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button className="p-2 rounded-lg hover:bg-red-50 transition-colors">
                          <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                          </svg>
                        </button>
                      </td>
                    </tr>

                    {/* Row 4 */}
                    <tr className="listing-row transition-colors hover:bg-red-50/50 cursor-pointer">
                      <td className="px-6 py-4">
                        <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-200 ring-2 ring-red-100">
                          <img
                            className="w-full h-full object-cover"
                            alt="Professional locksmith"
                            src="https://lh3.googleusercontent.com/aida-public/AB6AXuCKjqJ_i8BD-ab-JTFI8mjI04Q7K8xkFZXYsOk-f5aaWoPJRqFc2wkzHHEYpKSDpuv2xKacWrOF_2nTwKj8JKu7UOjxxffdUOiyg4QP4VXPrr8AqQUua67jB9jkF_ix7TPfjnDhydXRN1sA7plUA3bW0nAsmjGzSoLNXz9k3acLSe1lRDvodyNvfCecZFAZIFA-xqSXAprVvibKZT-rohJfEfG39uuhAjiOvN5EtWg2l4bEjYKwpOSxe8oMHDr-UNONX4RCFfq2l0U"
                          />
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div>
                          <p className="text-sm font-semibold text-gray-900">Robert Chen</p>
                          <p className="text-xs text-gray-500 mt-0.5">L-USA-5521</p>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-50 text-orange-700">
                          Seattle, WA
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button className="p-2 rounded-lg hover:bg-red-50 transition-colors">
                          <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          {/* Pagination Bar */}
          <footer className="px-4 md:px-8 py-4 bg-white border-t border-red-100 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-600">
              Showing <span className="font-semibold text-gray-900">1-10</span> of <span className="font-semibold text-gray-900">124</span> results
            </p>
            <div className="flex items-center gap-2">
              <button className="w-10 h-10 flex items-center justify-center rounded-xl border border-red-100 bg-white text-gray-400 hover:bg-red-50 transition-colors disabled:opacity-50" disabled>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <div className="flex items-center gap-1">
                <button className="w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-r from-red-600 to-rose-600 text-white font-semibold shadow-lg shadow-red-500/25">1</button>
                <button className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-red-50 text-gray-600 font-semibold transition-colors">2</button>
                <button className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-red-50 text-gray-600 font-semibold transition-colors">3</button>
                <span className="w-10 h-10 flex items-center justify-center text-gray-400">...</span>
                <button className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-red-50 text-gray-600 font-semibold transition-colors">12</button>
              </div>
              <button className="w-10 h-10 flex items-center justify-center rounded-xl border border-red-100 bg-white text-gray-600 hover:bg-red-50 transition-colors">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </footer>
        </main>

        {/* Toast Notification */}
        <div
          className="fixed bottom-8 right-8 bg-gray-900 text-white px-6 py-4 rounded-2xl shadow-2xl translate-y-24 transition-transform duration-300 flex items-center gap-4 z-50"
          id="actionToast"
        >
          <svg className="w-5 h-5 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm font-medium">Listing successfully updated.</p>
          <button className="text-gray-400 hover:text-white transition-colors" onClick={hideToast}>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <style jsx global>{`
          body {
            font-family: 'Hanken Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
            background-color: #fef2f2;
            color: #111827;
          }
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: transparent;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #fca5a5;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #f87171;
          }
          .listing-row {
            transition: all 0.2s ease;
          }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .listing-row {
            animation: fadeIn 0.3s ease forwards;
          }
        `}</style>
      </div>
    </>
  );
};

export default DashboardListings;